import { UpdateBorrowerAgePayloadtype } from '../../features/gms-proposal-forms/age-bracket-and-benefit-amount/age-bracket-and-benefit-amount.slice';

interface Props {
    isPreview: boolean;
    value: boolean | null;
    id: number;
    onChange: (id: number, value: boolean, type: UpdateBorrowerAgePayloadtype, label: string) => void;
    type: UpdateBorrowerAgePayloadtype;
    label: string;
}

export default function SwitchYesNo({ isPreview, value, id, onChange, type, label }: Props) {

    const isChecked = value === true;
    const isDisabled = isPreview || id === 2;
    const handleChange = () => {
        if (isDisabled) return;
        onChange(id, !isChecked, type, label);
    };

    return (
        <div className="flex min-w-0 items-center justify-center gap-1.5 sm:gap-2">
            <button
                type="button"
                role="switch"
                aria-checked={isChecked}
                aria-label={`${label}: ${isChecked ? "Yes" : "No"}`}
                onClick={handleChange}
                disabled={isDisabled}
                className={`relative inline-flex h-5 w-9 shrink-0 items-center rounded-full border transition-all duration-200 sm:h-6 sm:w-11 
                    ${ isChecked ? "border-[#186cb2] bg-[#186cb2]" : "border-gray-300 bg-gray-200" } 
                    ${isDisabled ? "cursor-not-allowed opacity-60" : "cursor-pointer hover:shadow-sm"}`}
            >
                <span className={`inline-block size-3.5 rounded-full bg-white shadow-sm transition-transform duration-200 sm:size-4 ${ isChecked ? "translate-x-[18px] sm:translate-x-6" : "translate-x-0.5 sm:translate-x-1" }`}/>
            </button>
            <span className={`min-w-[22px] text-[10px] font-medium sm:min-w-[24px] sm:text-xs ${isChecked ? "text-[#186cb2]" : "text-gray-500"}`}>
                {isChecked ? "Yes" : "No"}
            </span>
        </div>
    );
}